module.exports = __webpack_public_path__ + "static/media/memory.7030216b.png";